<script>
    import NewsletterInit, {
        newsletterSignupNumber,
    } from "../NewsletterInit.svelte";
    import RecaptchaInit from "../RecaptchaInit.svelte";

    /** Number of seconds before modal appears.
     * @type {number}
     */
    export let modalDelay = 3;

    export let modalSrc =
        "https://assets.propublica.org/static/prod/v5/js/deploy/syndicated-newsletter-v1.2.1.js";
    export let modalEndpoint =
        "https://www.propublica.org/partials/newsletter-roadblock-big-story-projects.propublica.org.html";
    export let modalStylesheet =
        "https://assets.propublica.org/static/prod/v5/css/deploy/syndicated-newsletter.css";
    export let stList = "the big story";
</script>

<div>
    <script
        data-syndicate
        src={modalSrc}
        data-delay={modalDelay}
        data-endpoint={modalEndpoint}
        data-stylesheet={modalStylesheet}
        data-stlist={stList}
    >
    </script>
</div>

<NewsletterInit />
{#if newsletterSignupNumber === 1}
    <RecaptchaInit />
{/if}
